var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.$slots.default,"disabled":_vm.tooltipShow,"placement":"top-start"}},[_c('span',{ref:"content",on:{"mouseover":_vm.isShowTooltip}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }